
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M2.461 14.493H14.54M4.048 12.481h8.904M5.498 12.338V7.5M4.997 7.497h1.022M7.997 7.497h1.022M11.023 7.497h1.022M8.506 12.338V7.5M11.522 12.338V7.5"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linejoin":"round","d":"M8.5 1.67 2.461 5.49H14.54z"}})])
          )
        }
      }
    